import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTag } from '@fortawesome/free-solid-svg-icons';
import { useAdmin } from '../../context/AdminContext';
import AdminDetailModal from '../shared/AdminDetailModal';
import '../../styles/modals/MenuVisualizationModal.css';

const PLACEHOLDER_IMAGE =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZTllY2VmIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzZjNzU3ZCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPk5vIEltYWdlPC90ZXh0Pjwvc3ZnPg==';

const MenuVisualizationModal = ({ show, onClose, menu }) => {
  const { categories, items } = useAdmin();
  const [menuCategories, setMenuCategories] = useState([]);
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    if (!menu) {
      return;
    }

    const filteredCategories = categories
      .filter((category) => category.menuId === menu.id && !category.isSystemCategory)
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
    setMenuCategories(filteredCategories);

    const allCategories = categories.filter((category) => category.menuId === menu.id);
    const categoryIds = allCategories.map((category) => category.id);
    const filteredItems = items
      .filter((item) => categoryIds.includes(item.categoryId) && item.status === 'active')
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
    setMenuItems(filteredItems);
  }, [categories, items, menu]);

  const getCategoryItems = (categoryId) => menuItems.filter((item) => item.categoryId === categoryId);

  if (!menu) {
    return null;
  }

  return (
    <AdminDetailModal
      show={show}
      onClose={onClose}
      title={menu.name}
      subtitle="Aktif menü önizlemesi"
      icon={faTag}
      summary={<div className="admin-chip admin-chip-accent">{menuCategories.length} kategori, {menuItems.length} aktif ürün</div>}
    >
      {menuCategories.length === 0 ? (
        <div className="admin-detail-placeholder">
          <FontAwesomeIcon icon={faTag} size="2x" />
          <span>Bu menüde henüz aktif kategori ve ürün bulunmuyor.</span>
        </div>
      ) : (
        <div className="menu-visualization-content">
          {menuCategories.map((category) => {
            const categoryItems = getCategoryItems(category.id);
            if (!categoryItems.length) {
              return null;
            }

            return (
              <div key={category.id} className="menu-category-section">
                <h3 className="category-title">
                  <FontAwesomeIcon icon={faTag} className="category-icon" />
                  {category.name}
                  <span className="item-count">({categoryItems.length} ürün)</span>
                </h3>
                <div className="menu-items-grid">
                  {categoryItems.map((item) => (
                    <div key={item.id} className="menu-item-card">
                      <div className="item-image-container">
                        <img
                          src={item.imageUrl || PLACEHOLDER_IMAGE}
                          alt={item.name}
                          className="item-image"
                          onError={(event) => {
                            event.target.src = PLACEHOLDER_IMAGE;
                          }}
                        />
                      </div>
                      <div className="item-details">
                        <h5 className="item-name">{item.name}</h5>
                        <p className="item-description">{item.description || 'Açıklama bulunmuyor'}</p>
                        <div className="item-price">₺{item.price || '0'}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </AdminDetailModal>
  );
};

export default MenuVisualizationModal;
